import axios from 'axios'
import { AxiosRedirectIntercepted } from './errors'

// Axios global setup, extracted from common.js so the interceptor behaviour can be
// unit-tested without pulling in Vue/SFC imports. Mirrors the service-module pattern
// used elsewhere (e.g. registrationService.js).

export const setAxiosHeaderToIndicateRequestIsAnAjaxOne = () => {
    // set this header so we can detect on the server if this is an ajax request
    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
}

export const setAxiosToInterceptRedirectsAndThrow = () => {
    axios.interceptors.response.use(response => {
        const redirectUrl = response && response.data && response.data.redirect
        if (redirectUrl) {
            window.location = redirectUrl
            // we throw an error here to break through any promise then's
            // straight to the catch
            throw new AxiosRedirectIntercepted()
        }

        return response
    })
}

export const setAxiosHeaderToAspAntiForgeryToken = () => {
    axios.interceptors.request.use(config => {
        if(config.method && config.method.toLowerCase() == "post")
        {
            const aspnetAntiForgeryToken = document.getElementsByName(
                '__RequestVerificationToken',
            )

            if (aspnetAntiForgeryToken.length === 0) {
                throw new Error('Could not find anti forgery token: input[name=__RequestVerificationToken] was not found');
            } else {
                config.headers['RequestVerificationToken'] = aspnetAntiForgeryToken[0].value
            }
        }
        return config
    })
}

// createApp() runs once per Vue island, but multiple islands on a page can share a
// single axios instance (e.g. Event/Index.v2.cshtml loads both event.index.js and the
// cart-drawer bundle). Guard on the axios instance so the global interceptors are wired
// exactly once per page load — otherwise the anti-forgery header injection and the
// redirect interceptor stack up and fire repeatedly.
export function setupAxios() {
    if (axios.__oztixInterceptorsConfigured) return;
    axios.__oztixInterceptorsConfigured = true;

    setAxiosHeaderToIndicateRequestIsAnAjaxOne();
    setAxiosToInterceptRedirectsAndThrow();
    setAxiosHeaderToAspAntiForgeryToken();
}
